// extracted by mini-css-extract-plugin
export default {"ResizeHandleInner":"ResizeHandle_ResizeHandleInner__dkJVS","ResizeHandleOuter":"ResizeHandle_ResizeHandleOuter__cT8es","Icon":"ResizeHandle_Icon__jiiTX"};